import { defineComponent as _defineComponent } from 'vue'
import FiltersDialog from "@/components/base/filters/FiltersDialog.vue";
import FiltersDesign from "@/components/base/filters/FiltersDesign.vue";
import { computed, onBeforeMount, ref } from "vue";
import { RegistrationsFilters } from "@/services/TablePage/registrations";
import store from "@/store";
import { useRegistrationsStore } from "@/store_v3/RegistrationsStore";
import { useWindowResize } from "@/utils/useWindowSize";


export default /*#__PURE__*/_defineComponent({
  __name: 'RegistrationsFilters',
  setup(__props) {


const { width } = useWindowResize();
const isDesktop = computed(() => width.value >= 768);
const isFullWidth = computed(() => width.value <= 576);
const getWidth = computed(() => isDesktop.value ? 1000 : isFullWidth.value ? 576 : 340);

const isShowFilters = ref(false);
const filters = ref<RegistrationsFilters>(null);
const { setUpdateRegistrationsFlag } = useRegistrationsStore();

onBeforeMount( () => {
    store.commit('SET_FILTERS_PARAMS_OBJECT', {});
    store.commit('SET_DEFAULT_FILTERS_PARAMS_OBJECT', {});
    filters.value = new RegistrationsFilters();
    filters.value.setDefaultFilters();
});

const submitFilters = () => {
    setUpdateRegistrationsFlag(true);
    isShowFilters.value = false;
};

const clearFilters = () => {
    setUpdateRegistrationsFlag(true);
    filters.value.parseRoute();
};

return { __sfc: true,width, isDesktop, isFullWidth, getWidth, isShowFilters, filters, setUpdateRegistrationsFlag, submitFilters, clearFilters, FiltersDialog, FiltersDesign }
}

})